import * as React from 'react';

function SvgIconIntroPay(props) {
  return (
    <svg viewBox="0 0 42 31" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <rect fill="#FCCE01" x={4.07} y={3.36} width={33.93} height={22.87} rx={3.84} />
        <path
          d="M11.04 0h22.49A4.43 4.43 0 0138 4.4v18.12c0 2.42-2 4.39-4.47 4.39H4.47A4.43 4.43 0 010 22.51v-12m0-4.56V4.39C0 1.97 2 0 4.47 0h1.67"
          stroke="#4C4C4C"
          strokeWidth={2.24}
          strokeLinecap="round"
        />
        <path
          d="M4.07 8.07h29.6M4.75 13.46h7.05m3.6 0h2.92"
          stroke="#4C4C4C"
          strokeWidth={2.1}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

export default SvgIconIntroPay;
